var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCrossGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 33.9167C12.2616 33.9203 6.63599 30.1641 4.24821 24.4009C1.86044 18.6377 3.18119 12.0035 7.59414 7.5942C11.4904 3.69795 17.1693 2.17629 22.4917 3.60242C27.8141 5.02854 31.9713 9.18579 33.3974 14.5082C34.8236 19.8305 33.3019 25.5095 29.4056 29.4057C26.5188 32.3056 22.5917 33.9299 18.4999 33.9167ZM6.16656 18.7651C6.23951 25.5504 11.7799 31.0022 18.5655 30.9659C25.351 30.9292 30.8325 25.4182 30.8325 18.6325C30.8325 11.8469 25.351 6.33585 18.5655 6.2992C11.7799 6.2629 6.23951 11.7147 6.16656 18.4999V18.7651ZM14.5054 24.6666L12.3332 22.4929L16.3261 18.4999L12.3332 14.507L14.507 12.3333L18.4999 16.3262L22.4928 12.3333L24.6666 14.507L20.6736 18.4999L24.6666 22.4929L22.4944 24.6666L18.4999 20.6737L14.507 24.6666H14.5054Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCrossGrey);
export default __webpack_public_path__ + "static/media/CircleCrossGrey.ae419febe24320458662a15c96844967.svg";
export { ForwardRef as ReactComponent };